import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import Html5FilledSvg from "@ant-design/icons-svg/es/asn/Html5Filled";
import AntdIcon from "../components/AntdIcon";
var Html5Filled = function Html5Filled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: Html5FilledSvg
  }));
};

/**![html5](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE0NS4yIDk2bDY2IDc0Ni42TDUxMiA5MjhsMjk5LjYtODUuNEw4NzguOSA5NkgxNDUuMnptNTk1IDE3Ny4xbC00LjggNDcuMi0xLjcgMTkuNUgzODIuM2w4LjIgOTQuMmgzMzUuMWwtMy4zIDI0LjMtMjEuMiAyNDIuMi0xLjcgMTYuMi0xODcgNTEuNnYuM2gtMS4ybC0uMy4xdi0uMWgtLjFsLTE4OC42LTUyTDMxMC44IDU3Mmg5MS4xbDYuNSA3My4yIDEwMi40IDI3LjdoLjRsMTAyLTI3LjYgMTEuNC0xMTguNkg1MTAuOXYtLjFIMzA2bC0yMi44LTI1My41LTEuNy0yNC4zaDQ2MC4zbC0xLjYgMjQuM3oiIC8+PC9zdmc+) */
var RefIcon = /*#__PURE__*/React.forwardRef(Html5Filled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'Html5Filled';
}
export default RefIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/icons/es/icons/Html5Filled.js
// module id = 2781
// module chunks = 0